// extracted by mini-css-extract-plugin
export default {"description":"sponsor-form-sign_description__56sQ0"};